document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("customers-frequently-viewed-wrapper");
  const carousel = document.getElementById("customers-frequently-viewed-carousel");
  const showMoreBtn = document.getElementById("customers-frequently-viewed-show-more");

  const current = window.location.pathname.split("/products/")[1]?.split("?")[0];
  const mapKey = 'viewed_products_map';
  const viewedMap = JSON.parse(localStorage.getItem(mapKey) || '{}');
  const handles = viewedMap[current] || [];

  if (!handles.length || !wrapper || !carousel) return;

  wrapper.style.display = "block";

  let maxInitial = 6;
  if (window.innerWidth < 480) maxInitial = 2;
  else if (window.innerWidth < 768) maxInitial = 3;
  else if (window.innerWidth < 1024) maxInitial = 4;

  const limitedHandles = handles.slice(-35); // Max 35
  Promise.all(
    limitedHandles.map(handle =>
      fetch(`/products/${handle}?section_id=product-card`)
        .then(res => res.text())
        .then(html => {
          const tmp = document.createElement("div");
          tmp.innerHTML = html.trim();
          return tmp.querySelector(".carousel-cell");
        }).catch(() => null)
    )
  ).then(cards => {
    cards = cards.filter(Boolean);
    cards.forEach((card, i) => {
      if (i >= maxInitial) card.classList.add("rv-hidden-product");
      carousel.appendChild(card);
    });

    const flkty = new Flickity(carousel, {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      autoPlay: window.innerWidth >= 768 ? 3000 : false,
      pauseAutoPlayOnHover: true,
      selectedAttraction: 0.015,
      friction: 0.25
    });

    if (cards.length > maxInitial) {
      showMoreBtn.style.display = "inline-block";
      let expanded = false;
      showMoreBtn.addEventListener("click", () => {
        expanded = !expanded;
        document.querySelectorAll(".rv-hidden-product").forEach((el) => {
          el.classList.toggle("rv-hidden-product", !expanded);
        });
        flkty.reloadCells();
        showMoreBtn.textContent = expanded ? "Show less" : "Show more";
      });
    }
  });
});
